import React, { useEffect, useState } from "react";
import "./ReferAndEarn.css"; // move your CSS here
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import walletBg from '../../assets/wallet-bg.png';
import iPhone from '../../assets/iPhone-Pro-Max.png';
import { DataContext } from "../../context/DataProvider";
import { useContext } from "react";
import companyLogo from "../../assets/logo/logo.png";
import { Link, useNavigate } from "react-router-dom";
import axiosMain from "../../axiosMain";
import { Button, Col, Modal, Nav, Row } from "react-bootstrap";
import Login from "../Login";
import ViewPaymentHistory from "../Payment/ViewPaymentHistory";
import PaymentModal from "../Payment/TopUpPayment";
import Header from "../../components/Header";
import award from "../../assets/icons/award.png";
import bg from "../../assets/icons/bg.png";
import gift from "../../assets/icons/award.png";
import gifticons from "../../assets/icons/gift-icon-dark.png";
import reply from "../../assets/icons/reply.png";
import send from "../../assets/icons/send.png";
import tiger from "../../assets/icons/tiger.png";
import link from "../../assets/icons/link.png";
import { BASE_URLS } from "../../utils/baseUrls";


const ReferAndEarn = ({ show, handleClose }) => {
    const { showSideBar, isLoggingOut, setIsLoggingOut, clearDataContext, searchType, tenderGPTData, resultGPTData, setLoading } = useContext(DataContext);
    const [showNotification, setShowNotification] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [walletBalance, setWalletBalance] = useState(0);
    const [walletBalanceInput, setwalletBalanceInput] = useState(null);
    const [topUpPaymentModal, setTopUpPaymentModal] = useState(false);
    const [objData, setObjData] = useState(null);
    const [viewPaymentModalIsOpen, setViewPaymentModalIsOpen] = useState(false);
    const [openModal, setopenModal] = useState(false);
    const [refCode, setRefCode] = useState("");
    const [copied, setCopied] = useState(false);

    const navigate = useNavigate();
    const clickWalletBalanceChange = (val) => {
        setwalletBalanceInput(val);
    }
    const toggleWalletCard = async () => {
        let localstoretoken = localStorage.getItem("logDetails");
        if (localstoretoken !== null) {
            var parseLocalStorage = JSON.parse(localstoretoken);

        }
        await axiosMain
            .post(BASE_URLS+"/Wallet/GetWalletBalance",
                {
                    UserId: parseLocalStorage === undefined ? 0 : parseLocalStorage.CustomerId,
                    UserDetailId: parseLocalStorage === undefined ? 0 : parseLocalStorage.UserDetailId,
                    DomainId: parseLocalStorage === undefined ? 0 : parseLocalStorage.DomainId,
                    ItemId: 0,
                    CreatedBy: 0,
                    ResultAmount: 0.0,
                    TenderAmount: 0.0,
                    EMDAmount: 0.0,
                    ReferenceBy: null,
                    TenderProcId: null,
                    ReferenceId: null,
                    Bidderids: null,
                    Querydata: null,
                    SubNo: null,
                    Offset: 0,
                    PageSize: 0,
                    FilterStartDate: null,
                    FilterEndDate: null,
                    ItemPrice: 0.0,
                    TenderListFlag: 0,
                    ReferenceDetailId: null
                }
            )
            ?.then((res) => {
                if (res.data.StatusCode === 200) {
                    // res.data.TransactionCurrency
                    setWalletBalance(res.data.Data.WalletBalance);
                    setIsVisible(!isVisible);
                }

            })
            ?.catch((err) => console.log(err));

    };
    const handleTopUp = async () => {
        let localstoretoken = localStorage.getItem("logDetails");
        if (localstoretoken !== null) {
            var parseLocalStorage = JSON.parse(localstoretoken);
        }

        await axiosMain
            .post(BASE_URLS + "/UserPayment/GenerateOrderTopUp",
                {
                    PayEmail: parseLocalStorage === undefined ? "" : parseLocalStorage.Email,
                    // IpAddress: "192.168.101.21",
                    UserId: parseLocalStorage === undefined ? 0 : parseLocalStorage.CustomerId,
                    UserDetailId: parseLocalStorage === undefined ? 0 : parseLocalStorage.UserDetailId,
                    // DomainUrl: "tendertiger.co.in",
                    NewOrRenew: "New User",
                    TopUpAmount: parseFloat(walletBalanceInput),
                    OrderFlag: 1,
                    ReferenceBy: null,
                    TenderProcId: 0,
                    ReferenceId: 0,
                    ItemId: 0,
                    ItemPrice: 0.0
                }
            )
            ?.then((res) => {
                if (res.data.StatusCode === 200) {
                    setObjData(res.data);
                    setIsVisible(!isVisible);
                    setTopUpPaymentModal(true);
                    setwalletBalanceInput(null);
                }

            })
            ?.catch((err) => console.log(err));

    };
    const fnlogout = () => {
        localStorage.removeItem("logDetails");
        localStorage.removeItem("token");
        setIsLoggingOut(false);
        clearDataContext();
    };


    const copyReferralLink = async () => {
        setLoading(true);
        let refCode = "";
        const logDetails = JSON.parse(localStorage.getItem("logDetails"));
        const userId = logDetails?.CustomerId;
        const userDetailsId = logDetails?.UserDetailId;
        const url = BASE_URLS + `/Registration/GetReferralLink?userId=${userId}&userDetailId=${userDetailsId}`;

        await axiosMain
            .get(url)
            .then((res) => {
                refCode = res?.data;
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });


        const referralLink = window.location.origin + "/User/Account?code=" + refCode
        setRefCode(referralLink);
    };
    useEffect(() => {
        if (show === true)
        {
             copyReferralLink();
        }
    }, [show]);

    const handleCopy = () => {
        navigator.clipboard.writeText(refCode).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} centered className="refer-earn-modal">
                <Modal.Header>
                    <div className="header-content">
                        <div className="w-100">
                            <h2>Refer & Earn</h2>
                            <span><strong>Earn 500 credits</strong> for every friend you invite!</span>
                        </div>
                        <img src={tiger} alt="tiger-image" />
                    </div>
                    <div className="" onClick={handleClose}>
                        <Button variant="link" className="btn-close p-0 m-0" onClick={handleClose}>
                            <i className="bi bi-x fs-4"></i>
                        </Button>
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <h4>How it works</h4>
                    <ul className="ps-2 list-unstyled">
                        <li className="d-flex align-items-center">
                            <img src={send} alt="share" />
                            <span className="ms-2">Share your invite link</span>
                        </li>
                        <li className="d-flex align-items-center mt-1">
                            <img src={gift} alt="gift" />
                            <span className="ms-2">
                                Your friend gets <strong>500 credits</strong> when they sign up
                            </span>
                        </li>
                        <li className="d-flex align-items-center mt-1">
                            <img src={award} alt="award" />
                            <span className="ms-2">
                                You earn <strong>500 credits</strong> when your friend signs up using your link
                            </span>
                        </li>
                    </ul>

                    <h4>What Can You Use Credits For?</h4>
                    <p>Unlock powerful features using your earned credits</p>
                    <ul className="ps-2 list-unstyled">
                        <li className="d-flex align-items-center">
                            <img src={reply} alt="discover" />
                            <span className="ms-2">Discover Government & Corporate Tenders</span>
                        </li>
                        <li className="d-flex align-items-center mt-1">
                            <img src={reply} alt="analyze" />
                            <span className="ms-2">Analyzing Competitors</span>
                        </li>
                        <li className="d-flex align-items-center mt-1">
                            <img src={reply} alt="summary" />
                            <span className="ms-2">Generating AI Summary</span>
                        </li>
                    </ul>
                </Modal.Body>

                <Modal.Footer className="modal-footer">
                    <h4 className="w-100">Your invite link</h4>
                    <div className="row w-100 align-items-center">
                        <div className="col-9 ps-0">
                            <div className="input-group">
                                <span className="input-group-text">
                                    <img src={link} alt="link" />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={refCode}
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="col-3 p-0">
                            <Button variant="dark" className="btn-copy w-100 d-flex align-items-center justify-content-center" onClick={handleCopy}>
                                {copied ? "Copied!" : "Copy Link"}
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* <PaymentModal show={topUpPaymentModal} handleClose={() => setTopUpPaymentModal(false)} objData={objData} />
            <ViewPaymentHistory PaymentModalIsOpen={viewPaymentModalIsOpen} handlePaymentModalClose={() => setViewPaymentModalIsOpen(false)} /> */}
        </>
    );
};

export default ReferAndEarn;
